import SafeLottie from './SafeLottie';
import { assets } from '../assetsConfig';

interface LoaderProps {
  text: string;
  onComplete?: () => void;
}

export default function Loader({ text, onComplete }: LoaderProps) {
  return (
    <div 
      className="w-full h-full flex flex-col items-center justify-center bg-[#FAF8F5]"
      aria-hidden="true"
      role="presentation"
    >
      <div className="w-[280px] h-[280px] shrink-0 flex items-center justify-center">
        <SafeLottie 
          animationData={assets.anim.loader} 
          loop={false}
          onComplete={onComplete}
          style={{ width: 280, height: 280 }}
        />
      </div>
      <p className="mt-6 text-[#125b60] font-bold tracking-widest uppercase text-sm animate-pulse text-center">
        {text}
      </p>
    </div>
  );
}